export const NAME_LOCALES = ['en', 'ko', 'ja', 'zh-Hans', 'zh-Hant', 'es', 'fr', 'de', 'pt-BR', 'ru', 'ar', 'hi', 'id', 'vi', 'fil', 'tr'];
export function normalizedNames(names = {}) {
  return Object.fromEntries(Object.entries(names).map(([locale, name]) => [locale, name.trim()]).filter(([, name]) => name));
}
export function nameErrors(names = {}) {
  const errors = {};
  for (const [locale, name] of Object.entries(names)) {
    if (!NAME_LOCALES.includes(locale) || typeof name !== 'string' || Array.from(name.trim()).length > 160) errors[locale] = true;
  }
  if (!names.en?.trim()) errors.en = true;
  return errors;
}
